import portal from "@/lib/portalApi";

const d = (r) => r.data;
const API_BASE = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

// ---- staff
export const billing = {
  entities: () => portal.get("/billing/entities").then(d),
  updateEntity: (code, body) => portal.patch(`/billing/entities/${code}`, body).then(d),
  catalog: (params = {}) => portal.get("/billing/catalog", { params }).then(d),
  createItem: (body) => portal.post("/billing/catalog", body).then(d),
  updateItem: (id, body) => portal.patch(`/billing/catalog/${id}`, body).then(d),
  loadStarter: () => portal.post("/billing/catalog/starter").then(d),
  overview: () => portal.get("/billing/overview").then(d),
  badge: () => portal.get("/billing/badge").then(d),
  forCase: (pid) => portal.get(`/billing/processes/${pid}`).then(d),
  proposals: (params = {}) => portal.get("/billing/proposals", { params }).then(d),
  createProposal: (pid, body) => portal.post(`/billing/processes/${pid}/proposals`, body).then(d),
  updateProposal: (id, body) => portal.put(`/billing/proposals/${id}`, body).then(d),
  proposalAction: (id, action, body = {}) => portal.post(`/billing/proposals/${id}/${action}`, body).then(d),
  invoices: (params = {}) => portal.get("/billing/invoices", { params }).then(d),
  invoice: (id) => portal.get(`/billing/invoices/${id}`).then(d),
  recordPayment: (id, body) => portal.post(`/billing/invoices/${id}/payments`, body).then(d),
  invoiceAction: (id, action, body = {}) => portal.post(`/billing/invoices/${id}/${action}`, body).then(d),
  recordFiscal: (id, number, file) => {
    const f = new FormData();
    f.append("number", number);
    if (file) f.append("file", file);
    return portal.post(`/billing/invoices/${id}/fiscal`, f).then(d);
  },
  payments: (status) => portal.get("/billing/payments", { params: status ? { status } : {} }).then(d),
  verifyPayment: (id, body = {}) => portal.post(`/billing/payments/${id}/verify`, body).then(d),
  rejectPayment: (id, reason) => portal.post(`/billing/payments/${id}/reject`, { reason }).then(d),
};

// Opens a PDF / Excel file that needs the auth header, in a new tab or as a download.
export async function openAuthed(path, filename) {
  const res = await portal.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  if (filename) {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  } else {
    window.open(url, "_blank", "noopener");
  }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

// ---- customer
export const myBilling = {
  get: () => portal.get("/account/billing").then(d),
  accept: (id, name) => portal.post(`/account/billing/proposals/${id}/accept`, { name }).then(d),
  decline: (id, reason) => portal.post(`/account/billing/proposals/${id}/decline`, { reason }).then(d),
  uploadProof: (id, amount, reference, file) => {
    const f = new FormData();
    f.append("amount", amount);
    f.append("reference", reference || "");
    f.append("file", file);
    return portal.post(`/account/billing/invoices/${id}/proof`, f).then(d);
  },
  payCard: (id) => portal.post(`/account/billing/invoices/${id}/pay-card`).then(d),
};

export const fmtMoney = (v, cur) => {
  const n = Number(v || 0);
  return `${n.toLocaleString("pt-PT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${cur || ""}`.trim();
};

export const STATUS_STYLES = {
  draft: "bg-slate-500/15 text-slate-300 border-slate-500/30",
  pending_approval: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  approved: "bg-sky-500/15 text-sky-300 border-sky-500/30",
  sent: "bg-indigo-500/15 text-indigo-300 border-indigo-500/30",
  accepted: "bg-green-500/15 text-green-300 border-green-500/30",
  declined: "bg-red-500/15 text-red-300 border-red-500/30",
  expired: "bg-slate-500/15 text-slate-400 border-slate-500/30",
  cancelled: "bg-slate-500/15 text-slate-400 border-slate-500/30",
  open: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  partially_paid: "bg-sky-500/15 text-sky-300 border-sky-500/30",
  paid: "bg-green-500/15 text-green-300 border-green-500/30",
  credited: "bg-purple-500/15 text-purple-300 border-purple-500/30",
  issued: "bg-purple-500/15 text-purple-300 border-purple-500/30",
  pending_verification: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  pending_card: "bg-slate-500/15 text-slate-300 border-slate-500/30",
  confirmed: "bg-green-500/15 text-green-300 border-green-500/30",
  rejected: "bg-red-500/15 text-red-300 border-red-500/30",
};

export const StatusPill = ({ status, label }) => (
  <span className={`inline-flex items-center whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] font-medium ${STATUS_STYLES[status] || STATUS_STYLES.draft}`}>
    {label || String(status || "").replace(/_/g, " ")}
  </span>
);

export { API_BASE };
